module.exports = __webpack_public_path__ + "static/textmaster-apisecret-a67529e7d866bf4295e6c607081ea16a.jpg";